import * as RadixDialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

export const Dialog = RadixDialog.Root;
export const DialogTrigger = RadixDialog.Trigger;
export const DialogClose = RadixDialog.Close;

export function DialogOverlay({ className, ...props }: RadixDialog.DialogOverlayProps) {
  return (
    <RadixDialog.Overlay
      className={cn(
        'fixed inset-0 z-50 bg-[#1C1915]/25 backdrop-blur-[2px] data-[state=open]:animate-fade-in',
        className,
      )}
      {...props}
    />
  );
}

export function DialogContent({ className, children, ...props }: RadixDialog.DialogContentProps) {
  return (
    <RadixDialog.Portal>
      <DialogOverlay />
      <RadixDialog.Content
        className={cn(
          'fixed inset-0 m-auto z-50 flex flex-col w-[calc(100%-2rem)] max-w-lg max-h-[90svh] h-fit rounded border border-border bg-bg-surface shadow-lift focus:outline-none data-[state=open]:animate-slide-up',
          className,
        )}
        {...props}
      >
        <div className="overflow-y-auto min-h-0 flex-1 p-4 sm:p-6">
          {children}
        </div>
        <RadixDialog.Close className="absolute right-4 top-4 rounded-sm p-1 text-text-muted transition-colors hover:text-text-primary focus:outline-none">
          <X className="h-4 w-4" />
        </RadixDialog.Close>
      </RadixDialog.Content>
    </RadixDialog.Portal>
  );
}

export function DialogHeader({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('mb-5 flex flex-col gap-1', className)} {...props} />;
}

export function DialogTitle({ className, ...props }: RadixDialog.DialogTitleProps) {
  return (
    <RadixDialog.Title
      className={cn('font-serif text-lg text-text-primary', className)}
      {...props}
    />
  );
}

export function DialogDescription({ className, ...props }: RadixDialog.DialogDescriptionProps) {
  return (
    <RadixDialog.Description
      className={cn('text-sm text-text-secondary', className)}
      {...props}
    />
  );
}
